export interface IEnvVars {
  VITE_API_SERVER: string;
  VITE_API_VERSION: string;
  VITE_PORTAL_REGION: string;
  VITE_REDIRECT_URL: string;
  VITE_DRIVER_PORTAL_URL: string;
  VITE_GLOBAL_SERVICE_API_TOKEN: string;
  VITE_GLOBAL_API_SERVER: string;
  VITE_REGION: string;
  VITE_USER_POOL_ID: string;
  VITE_USER_POOL_CLIENT_ID: string;
  VITE_OAUTH_DOMAIN: string;
  VITE_SIGNATURE_KEY: string;
  VITE_COUNTRYID: string;
  VITE_CARD_COLLECTIONID: string;
  VITE_IV_ENCRYPTION_KEY: string;
  VITE_IV_INIT_VECTOR: string;
}

export const env: IEnvVars = {
  VITE_API_SERVER: import.meta.env.VITE_API_SERVER,
  VITE_API_VERSION: import.meta.env.VITE_API_VERSION,
  VITE_PORTAL_REGION: import.meta.env.VITE_PORTAL_REGION,
  VITE_REDIRECT_URL: import.meta.env.VITE_REDIRECT_URL,
  VITE_DRIVER_PORTAL_URL: import.meta.env.VITE_DRIVER_PORTAL_URL,
  VITE_GLOBAL_SERVICE_API_TOKEN: import.meta.env.VITE_GLOBAL_SERVICE_API_TOKEN,
  VITE_GLOBAL_API_SERVER: import.meta.env.VITE_GLOBAL_API_SERVER,
  VITE_REGION: import.meta.env.VITE_REGION,
  VITE_USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID,
  VITE_USER_POOL_CLIENT_ID: import.meta.env.VITE_USER_POOL_CLIENT_ID,
  VITE_OAUTH_DOMAIN: import.meta.env.VITE_OAUTH_DOMAIN,
  VITE_SIGNATURE_KEY: import.meta.env.VITE_SIGNATURE_KEY,
  VITE_COUNTRYID: import.meta.env.VITE_COUNTRYID,
  VITE_CARD_COLLECTIONID: import.meta.env.VITE_CARD_COLLECTIONID,
  VITE_IV_ENCRYPTION_KEY: import.meta.env.VITE_IV_ENCRYPTION_KEY,
  VITE_IV_INIT_VECTOR: import.meta.env.VITE_IV_INIT_VECTOR,
};
